//#region src/breakpoints.ts
/**
* The raw viewport widths the design system is built on.
*
* Kept in its own module, and exported as `@kimuno/theme/breakpoints`, because
* it is plain data with no MUI import: consumers that run outside a bundler
* (apps/web's `cypress.config.ts`, loaded by ts-node) can read it without
* pulling MUI's ESM, which Node cannot load against React 17.
*/
const breakpoints = {
	mobile: 743,
	tablet: 1023,
	desktop: 1920,
	sidebarBreakpoint: 1216
};

//#endregion
export { breakpoints };
//# sourceMappingURL=breakpoints.mjs.map